import Link from 'next/link'

const NavLink: React.FC<NavLinkProps> = ({
  children,
  href,
  shallow = true,
}) => (
  <Link
    href={href ?? 'javascript:void(0)'}
    passHref={!href}
    shallow={shallow}
    legacyBehavior
  >
    {children}
  </Link>
)

export default NavLink
